import CollapseElem from 'Components/Collapse';
import { Container, Item } from 'Components/Grid';
import HistorySection from 'Components/HistorySection';
import { withHistoryContext } from 'Containers/FormContextHandler';
import { sortPartialDate } from 'neuro-utils';
import * as React from 'react';
import { newButton } from '../../../../utils/functions';
import { TreatmentPeriodEventListItem } from '../components';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'contraIndicationsToTreatment'>[] = [];
const ContraIndicationToTreatmentHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
  treatmentPeriod,
}: IHistoryContext<IDocumentWithTypeV2<'contraIndicationsToTreatment'>> & {
  treatmentPeriod: IDocumentWithTypeV2<'ninmtTreatmentPeriod'>;
}): React.JSX.Element => {
  const treatmentId = treatmentPeriod._id;

  const contraIndicationsToTreatments = documents
    .filter(d => d.treatmentPeriodId === treatmentId)
    .sort((n1, n2) => sortPartialDate(n2.date, n1.date));

  return (
    <HistorySection
      headerText={
        <span style={{ fontSize: '2.2rem' }}>{fm('diagnosis.ninmt.contraIndicationsToTreatment.title')}</span>
      }
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'contraIndicationsToTreatment',
              (e: React.MouseEvent): void => {
                if (!treatmentId) return;
                startEdit({}, 'contraIndicationsToTreatment', { treatmentPeriodId: treatmentId })(e);
              },
              'general.new',
              15,
              true,
              treatmentPeriod._editing ?? !treatmentPeriod.date,
              'diagnosis.ninmt.treatmentPeriodDisabledTooltip',
            )
          : undefined
      }
    >
      <React.Fragment>
        <Container>
          <Item xs={0} md={3} lg={3} />
          <Item xs={12} md={9} lg={9}>
            {contraIndicationsToTreatments.length > 0 && (
              <div style={{ marginBottom: contraIndicationsToTreatments.length > 1 ? '4.5rem' : undefined }}>
                <TreatmentPeriodEventListItem
                  treatmentPeriodEvent={contraIndicationsToTreatments[0]}
                  startEdit={startEdit}
                  fm={fm}
                />
              </div>
            )}
            {contraIndicationsToTreatments.length > 1 && (
              <CollapseElem
                localeIDs={{
                  showMessage: 'diagnosis.ninmt.contraIndicationsToTreatment.showPastContraIndications',
                  hideMessage: 'diagnosis.ninmt.contraIndicationsToTreatment.hidePastContraIndications',
                }}
                amount={contraIndicationsToTreatments.slice(1).length}
                collapseButtonPosition={'flex-start'}
              >
                {contraIndicationsToTreatments.slice(1).map((e, i, arr) => (
                  <div key={i} style={{ marginBottom: i < arr.length - 1 ? '4.5rem' : undefined }}>
                    <TreatmentPeriodEventListItem treatmentPeriodEvent={e} startEdit={startEdit} fm={fm} />
                  </div>
                ))}
              </CollapseElem>
            )}
          </Item>
        </Container>
      </React.Fragment>
    </HistorySection>
  );
};

export default withHistoryContext(ContraIndicationToTreatmentHistory);
